import dalmoreHeaderLogo from '@/assets/img/dalmore/logo.svg'
import dalmoreHeaderSocialBg from '@/assets/img/dalmore/social-bg.svg'
import dalmoreLoadingIcon from '@/assets/img/dalmore/logo-deer.png'

import juraHeaderLogo from '@/assets/img/jura/logo.svg'
import juraHeaderSocialBg from '@/assets/img/jura/social-bg.svg'

import fettercairnHeaderLogo from '@/assets/img/fettercairn/logo.png'
import fettercairnHeaderSocialBg from '@/assets/img/fettercairn/social-bg.svg'
import fettercairnLoadingIcon from '@/assets/img/fettercairn/logo-loading.svg'

import tamnavulinHeaderLogo from '@/assets/img/tamnavulin/logo.png'
import tamnavulinHeaderSocialBg from '@/assets/img/tamnavulin/social-bg.svg'
export default {
  dalmore: {
    favIcon: '/favicon.ico',
    loading: {
      iconUrl: dalmoreLoadingIcon,
    },
    header: {
      logoUrl: dalmoreHeaderLogo,
      share: {
        backgroundUrl: dalmoreHeaderSocialBg,
      },
    },
  },
  jura: {
    favIcon: '/favicon_jura.ico',
    loading: {
      iconUrl: '',
    },
    header: {
      logoUrl: juraHeaderLogo,
      share: {
        backgroundUrl: juraHeaderSocialBg,
      },
    },
  },
  fettercairn: {
    favIcon: '/favicon_fettercairn.ico',
    loading: {
      iconUrl: fettercairnLoadingIcon,
    },
    header: {
      logoUrl: fettercairnHeaderLogo,
      share: {
        backgroundUrl: fettercairnHeaderSocialBg,
      },
    },
  },
  tamnavulin: {
    favIcon: '/favicon_tamnavulin.ico',
    loading: {
      iconUrl: '',
    },
    header: {
      logoUrl: tamnavulinHeaderLogo,
      share: {
        backgroundUrl: tamnavulinHeaderSocialBg,
      },
    },
  },
}
